export default __webpack_public_path__ + "node_modules/flag-icon-css/flags/1x1/hu.svg";